import ajax from '../../../components/ajax';
export default function useProductApi(productId) {
    function request() {
        return ajax("/api/product/".concat(productId), {})
            .then(function (response) { return response.json(); });
    }
    return { request: request };
}
